import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { Recommendation } from 'src/app/modules/course-acc-inspection-report/models/recommendation';
import { Furniture } from 'src/app/modules/stp-registration/models/furniture.model';
import { StpManagement } from 'src/app/modules/stp-registration/models/stp-management.model';
import { StpOccupationTool } from 'src/app/modules/stp-registration/models/stp-occupation-tool.model';
import { StpTrainer } from 'src/app/modules/stp-registration/models/stp-trainer.model';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
import { environment } from 'src/environments/environment';
import { fileDeleteRequest } from 'src/app/modules/course-acc-inspection-report/DTO/fileDeleteRequest';
import { Location } from '@angular/common';
import { StpSacScrutinyResultDto } from 'src/app/modules/course-accreditation/DTO/StpSacScrutinyResultDto';
import { StpSacInspectionRegistrationReport } from 'src/app/modules/course-accreditation/models/stp-sac-inspection-registration-report.model';
import { InspectionRegistrationReport } from 'src/app/modules/course-accreditation/models/inspection-registration-report.model';
import { InspectionRegistrationRecord } from 'src/app/modules/course-accreditation/models/inspection-registration-record.model';
import { InspectionAttachment } from 'src/app/modules/course-accreditation/models/inspection-attachment.model';
import { InspectorRecommendation } from 'src/app/modules/course-accreditation/models/inspector-recommendation.model';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { Attachment } from 'src/app/modules/course-accreditation/models/attachment';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { StpRegistrationRenewReapplyService } from '../../../services/stp-registration-renew-reapply.service';

@Component({
  selector: 'app-stp-sac-inspection-renew-reapply',
  templateUrl: './stp-sac-inspection-renew-reapply.component.html',
  styleUrls: ['./stp-sac-inspection-renew-reapply.component.scss'],
})
export class StpSacInspectionRenewReapplyComponent implements OnInit {
  stpSacInspectionForm: FormGroup;
  inspectionForm: FormGroup;
  scrutinyForm: FormGroup;

  basicProfileForm: any;
  physicalInfraForm: any;
  financialDetailForm: any;
  transactionNumber: any;
  basicData: any;

  totalIncomes: number;
  totalExpenses: number;
  inspectionId: number;
  modalTabName: string;
  modalTitle: string;
  paySlip: String;

  reportId: number;
  isFileUpload = false;

  isComplete$: Subscription;
  routeSub: Subscription;

  isManualPayment = false;
  isOnlinePayment = false;
  isVisible = false;
  isVisibleForAttachment = false;
  isOkLoading = false;
  isApplicationSubmitted: boolean = false;
  isCommitte: boolean;

  response: any;

  stpSacScrutinyResult: StpSacScrutinyResultDto;
  stpTrainers: StpTrainer[] = [];
  stpOccupationTools: StpOccupationTool[] = [];
  furnitures: Furniture[] = [];
  stpManagements: StpManagement[] = [];
  recommendations: Recommendation[] = [];
  stpSacInspectionRegistrationReportList: StpSacInspectionRegistrationReport[] =
    [];
  inspectionRegistrationReport: InspectionRegistrationReport[] = [];
  inspectionRegistrationRecords: InspectionRegistrationRecord[] = [];
  inspectionAttachment: InspectionAttachment[] = [];
  inspectorRecomendation: InspectorRecommendation;

  isCorrectList: { id: number; name: string }[] = [
    { id: 1, name: 'Found Correct' },
    { id: 0, name: 'Not Correct' },
  ];

  scrutinyList: { id: number; name: string }[] = [
    // { id: 0, name: 'Agree with inspection result' },
    // { id: 1, name: 'Need clarification' },
    // { id: 1, name: 'Disagree with inspection result' },
  ];

  stpInformations: { name: string; modalIdentity: string }[] = [
    { name: 'Basic Profile', modalIdentity: 'basic' },
    { name: 'Physical Infrastructure Details', modalIdentity: 'Physical' },
    { name: 'Occupation Specific Trainer', modalIdentity: 'occupation' },
    { name: 'Management and Supporting Staff', modalIdentity: 'management' },
    { name: 'Financial Details', modalIdentity: 'financial' },
    {
      name: 'Tools/Equipment/Training Learning Materials',
      modalIdentity: 'tools',
    },
    { name: 'Furniture', modalIdentity: 'furniture' },
  ];

  //#region file preview and upload
  fileList: any[] = [];
  previewAttachments: Attachment[] = [];
  imageTypeArray: string[] = ['jpg', 'jpeg', 'png'];

  imageView: boolean;
  isImageLoading: boolean;
  imageURL: any;
  pdfUrl: any;
  otherPdfUrl: any;
  pdfSource = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  stpMainId: number;
  inspectionRegistrationReportId: number | null;

  @ViewChild('myInput') fileElement: ElementRef;

  saveBtnDisabled: boolean = false;
  // set once the NSDA officer has submitted the inspection completion; the report is then locked
  isNsdaSubmitted = false;

  //#endregion file preview and upload

  constructor(
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NzNotificationService,
    private sanitizer: DomSanitizer,
    private inspectionStorageService: InspectionStorageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    private stpRegistrationService: StpRegistrationService,
    private location: Location,
  ) {
    this.inspectionStorageService.getRecommendationByType('rs').subscribe({
      next: (res) => {
        this.recommendations = res.data;
      },
    });

    this.inspectionStorageService.getRecommendationByType('s').subscribe({
      next: (res) => {
        this.scrutinyList = res.data;
      },
    });

    this.inspectionId = this.route.snapshot.params.inspectionId;
    this.onStpSacInspectionPreviewByInspectionId(this.inspectionId);
  }

  ngOnInit(): void {
    this.inspectionForm = this.fb.group({
      inspectionFormArray: this.fb.array([]),
      recommendation: this.fb.group({
        inspectorRecommendationId: [null, Validators.required],
        inspectorRemarks: [null],
        inspectionId: [this.inspectionId],
        stpMainId: [], // FIXME: Hardcode STP Main Id
        // scrutinyId: [null],
        // remarks: [null],
      }),
      files: [[]],
    });

    this.scrutinyForm = this.fb.group({
      inspectionRegistrationReportId: [], // FIXME: Hardcode inspectionRegistrationReportId
      scrutinyResultId: [null],
      scrutinyResultRemarks: [null],
      scrutinyRecommendationId: [null],
      scrutinyRecommendationRemarks: [null],
    });

    this.route.queryParams.subscribe((params) => {
      this.stpMainId = parseInt(params['stpMainId'] ?? '0');
      this.inspectionRegistrationReportId = parseInt(
        params['inspectionRegistrationReportId'] ?? '0',
      );
      this.inspectionForm
        ?.get('recommendation.stpMainId')
        ?.setValue(this.stpMainId === 0 ? null : this.stpMainId);
      this.scrutinyForm
        ?.get('inspectionRegistrationReportId')
        ?.setValue(
          this.inspectionRegistrationReportId === 0
            ? null
            : this.inspectionRegistrationReportId,
        );
    });

    this.inspectorRecommendationId?.valueChanges.subscribe((value) => {
      if (value == 2) {
        this.inspectorRemarks?.setValidators([Validators.required]);
        this.inspectorRemarks?.updateValueAndValidity();
      } else {
        this.inspectorRemarks?.clearValidators();
        this.inspectorRemarks?.updateValueAndValidity();
      }
    });
  }

  get inspectionFormArray(): FormArray {
    return this.inspectionForm.get('inspectionFormArray') as FormArray;
  }

  get inspectorRecommendationId() {
    return this.inspectionForm.get('recommendation.inspectorRecommendationId');
  }

  get inspectorRemarks() {
    return this.inspectionForm.get('recommendation.inspectorRemarks');
  }

  onSelectNIDorBirthRegFile(event: any): void {
    const file = event.target.files[0];
    const target: DataTransfer = event.target as DataTransfer;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
  }

  submitForm(): void {
    this.saveBtnDisabled = true;
    let inspectionFormData = { ...this.inspectionForm.value };
    let inspectionRecords = [...inspectionFormData.inspectionFormArray];
    if (inspectionRecords?.length > 0) {
      inspectionRecords.forEach((item: any, index: number) => {
        delete item.name;
        delete item.modalIdentity;
      });
    }

    if (this.previewAttachments.length <= 0) {
      this.notification.warning('Warning', 'Please upload document first !');
    } else {
      this.stpRegistrationRenewReapplyService
        .saveStpAndSacRegInspectionReport(inspectionFormData, this.fileList)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.notification.success(
                'Success!',
                'STP/ SAC registration inspection report Information saved successfully',
              );
              this.previewAttachments = response?.data?.inspectionAttachment;
              this.setPreviousAttachments();
              this.fileList = [];

              // this.router.navigate([
              //   'home/course-accreditation/complete-inspection/' +
              //     this.inspectionId,
              // ]);

              this.location.back();
            } else {
              this.notification.error('Failed!', response.message);
            }
            this.saveBtnDisabled = false;
          },
          error: (error) => {
            (this.notification.error('Failed', error),
              (this.saveBtnDisabled = false));
          },
        });
    }

    // if (this.isFileUpload) {
    // this.inspectionStorageService
    //   .saveStpAndSacRequestInspectionReport(inspectionFormData, this.fileList)
    //   .subscribe({
    //     next: (response) => {
    //       if (response.success) {
    //         this.notification.success(
    //           'Success!',
    //           'STP/ SAC registration inspection report Information saved successfully'
    //         );
    //         this.router.navigate([
    //           'home/course-accreditation/complete-inspection/' +
    //             this.inspectionId,
    //         ]);

    //         this.previewAttachments = response.data?.inspectionAttachment;
    //         this.setPreviousAttachments();
    //         this.fileList = [];
    //       }else{
    //         this.notification.error(
    //           'Failed!',
    //           response.message
    //         );
    //       }
    //       this.saveBtnDisabled = false;
    //     },
    //     error: (error) => {
    //       this.notification.error('Failed', error),
    //       this.saveBtnDisabled = false;
    //     },
    //   });
    // }
    // else if(this.isFileUpload == false && this.previewAttachments.length>0){
    //   this.isFileUpload = true;
    //   this.inspectionStorageService
    //   .saveStpAndSacRequestInspectionReport(inspectionFormData, this.fileList)
    //   .subscribe({
    //     next: (response) => {
    //       if (response.success) {
    //         this.notification.success(
    //           'Success!',
    //           'STP/ SAC registration inspection report Information saved successfully'
    //         );
    //         this.router.navigate([
    //           'home/course-accreditation/complete-inspection/' +
    //             this.inspectionId,
    //         ]);
    //       }else{
    //         this.notification.error(
    //           'Failed!',
    //           response.message
    //         );
    //       }
    //       this.saveBtnDisabled = false;
    //     },
    //     error: (error) => {
    //       this.notification.error('Failed', error),
    //       this.saveBtnDisabled = false;
    //     },
    //   });
    // }
    // else
    // {
    //   this.notification.error(
    //     'Failed',
    //     'Please upload file and try again.'
    //   );
    //   this.saveBtnDisabled = false;
    // }
  }

  isValidFileList(): boolean {
    return !!(this.previewAttachments?.length >= 0);
  }

  submitScrutinyForm(): void {
    this.stpSacScrutinyResult = this.scrutinyForm.value;
    this.inspectionStorageService
      .saveScrutinyForStpStacInspectionReport(this.stpSacScrutinyResult)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.notification.success(
              'Success!',
              'Scrutiny Information saved successfully',
            );
          }
        },
        error: (error) => this.notification.error('Failed', error),
      });
  }

  //#region Modal
  showModal(modalName: string, modalTitle: string = ''): void {
    this.modalTabName = modalName;
    this.modalTitle = modalTitle;
    this.isVisible = true;
  }

  handleOk(): void {
    this.isOkLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isOkLoading = false;
    }, 3000);
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  private toNumber(value: any): number {
    const parsedValue = parseFloat(value ?? 0);
    return isNaN(parsedValue) ? 0 : parsedValue;
  }

  private getStpApplicationById() {
    this.stpRegistrationRenewReapplyService
      .readStpInfoByStpMainId(this.stpMainId)
      .subscribe(
        (res) => {
          if (res.success) {
            const data = res.data;
            const stpUserInfo = data?.stpUserInfoDto ?? {};
            const infrastructure = data?.stpInfrastructures ?? {};
            const fund = data?.stpFund ?? {};
            const income = data?.stpIncome ?? {};
            const expense = data?.stpExpense ?? {};

            this.basicData = data;
            this.isCommitte = stpUserInfo?.isCommittee === true;
            this.basicProfileForm = {
              stpName: stpUserInfo?.stpName,
              stpNameBangla: stpUserInfo?.stpNameBangla,
              stpType: stpUserInfo?.stpType?.typeName ?? stpUserInfo?.stpType,
              stpOwnershipType:
                stpUserInfo?.stpOwnershipType?.typeName ??
                stpUserInfo?.ownershipType,
              stpMinistry:
                stpUserInfo?.stpMinistry?.ministryName ??
                stpUserInfo?.ministryName,
              stpAgency:
                stpUserInfo?.stpAgency?.agencyName ?? stpUserInfo?.agencyName,
              establishYear: this.datepipe.transform(
                stpUserInfo?.establishYear,
                'yyyy',
              ),
              stpLocation:
                stpUserInfo?.stpLocation?.locationName ??
                stpUserInfo?.locationName,

              stpCountry:
                stpUserInfo?.sysCountry?.countryName ?? stpUserInfo?.country,
              stpPostOffice: stpUserInfo?.postOffice,
              address: stpUserInfo?.address,
              contactNo: stpUserInfo?.contactNo ?? stpUserInfo?.orgContact,
              email: stpUserInfo?.email ?? stpUserInfo?.orgEmail,
              division:
                stpUserInfo?.sysDivision?.divisionName ?? stpUserInfo?.division,
              district:
                stpUserInfo?.sysDistrict?.districtName ?? stpUserInfo?.district,
              upazilla:
                stpUserInfo?.sysUpazilla?.upazillaName ??
                stpUserInfo?.upazilla,

              contactName: stpUserInfo?.contactName,
              contactDesignation: stpUserInfo?.contactDesignation,
              contactNumber: stpUserInfo?.contactNumber,
              contactEmail: stpUserInfo?.contactEmail,

              isCommitte: stpUserInfo?.isCommittee,
              isCommittee: stpUserInfo?.isCommittee,
              totalMember:
                data?.stpCommittee?.totalNumber ?? stpUserInfo?.totalMember,
              totalFemaleMember:
                data?.stpCommittee?.totalFemaleMember ??
                stpUserInfo?.totalFemaleMember,
              approvalDateCommittee: this.datepipe.transform(
                data?.stpCommittee?.approvalDate ?? stpUserInfo?.approvalDate,
                'dd-MM-yyyy',
              ),
              expirationDateCommittee: this.datepipe.transform(
                data?.stpCommittee?.expireDate ?? stpUserInfo?.expireDate,
                'dd-MM-yyyy',
              ),
              c: stpUserInfo?.isCommittee,
            };
            this.physicalInfraForm = {
              ownershipBuilding:
                stpUserInfo?.ownershipBuilding ??
                infrastructure?.stpBuildingType?.typeName,
              constructionBuilding:
                stpUserInfo?.constructionBuilding ??
                infrastructure?.stpOwnershipStatus?.typeName,
              totalArea: stpUserInfo?.totalArea ?? infrastructure?.totalArea,
              floor: stpUserInfo?.floor ?? infrastructure?.noOfFloor,
              classroom:
                stpUserInfo?.classroom ?? infrastructure?.noOfClassroom,
              classroomSize:
                stpUserInfo?.classroomSize ?? infrastructure?.sizeOfClassroom,
              workshop: stpUserInfo?.workshop ?? infrastructure?.noOfWorkshop,
              workshopSize:
                stpUserInfo?.workshopSize ?? infrastructure?.sizeOfWorkshop,
              noOfComputerLabs:
                stpUserInfo?.noOfComputerLabs ?? infrastructure?.noOfClub,
              sizeOfComputerLabs:
                stpUserInfo?.sizeOfComputerLabs ?? infrastructure?.sizeOfClub,
              office: stpUserInfo?.office ?? infrastructure?.noOfOffice,
              trainingRoom:
                stpUserInfo?.trainingRoom ?? infrastructure?.noOfTrainerRoom,
              washroom:
                stpUserInfo?.washroom ?? infrastructure?.noOfWashroom,
              femaleWashroom:
                stpUserInfo?.femaleWashroom ??
                infrastructure?.noOfFemaleWashroom,
              isDisableFriendly:
                stpUserInfo?.isDisableFriendly ??
                infrastructure?.isDisableFriendly,
              isElectricity:
                stpUserInfo?.isElectricity ?? infrastructure?.isElectricity,
              isInternet:
                stpUserInfo?.isInternet ?? infrastructure?.isInternet,
              isDrinkingWater:
                stpUserInfo?.isDrinkingWater ??
                infrastructure?.isDrinkingWater,
              isFireEq: stpUserInfo?.isFireEq ?? infrastructure?.isFireEq,
              isLibrary: stpUserInfo?.isLibrary ?? infrastructure?.isLibrary,
              isLightingVent:
                stpUserInfo?.isLightingVent ??
                infrastructure?.isLightingVent,
            };

            this.financialDetailForm = {
              reserveFund: this.toNumber(
                stpUserInfo?.reserveFund ?? fund?.reserveFund,
              ),
              fdr: this.toNumber(stpUserInfo?.fdr ?? fund?.fdr),
              generalFund: this.toNumber(
                stpUserInfo?.generalFund ?? fund?.generalFund,
              ),
              availableBalanceInBankAccount: this.toNumber(
                stpUserInfo?.availableBalance ?? fund?.availableBalance,
              ),
              accountNumber: stpUserInfo?.accountNo ?? fund?.accountNo,
              bankName: stpUserInfo?.bankName ?? fund?.bankName,
              branchName: stpUserInfo?.branchName ?? fund?.branchName,
              otherFunds: this.toNumber(
                stpUserInfo?.otherFund ?? fund?.otherFund,
              ),
              remarks: stpUserInfo?.remarks ?? fund?.remarks,
              feesFromStudents: this.toNumber(
                stpUserInfo?.feesFromStudent ?? income?.feesFromStudent,
              ),
              incomeFromOwnAssets: this.toNumber(
                stpUserInfo?.ownAssetIncome ?? income?.ownAssetIncome,
              ),
              fromGovernment: this.toNumber(
                stpUserInfo?.govIncome ?? income?.govIncome,
              ),
              developmentCharge: this.toNumber(
                stpUserInfo?.developmentCharge ?? income?.developmentCharge,
              ),
              admissionFee: this.toNumber(
                stpUserInfo?.admissionFee ?? income?.admissionFee,
              ),
              examinationFee: this.toNumber(
                stpUserInfo?.examFee ?? income?.examFee,
              ),
              sessionCharge: this.toNumber(
                stpUserInfo?.sessionCharge ?? income?.sessionCharge,
              ),
              sellingOfProductsProduced: this.toNumber(
                stpUserInfo?.prodSell ?? income?.prodSell,
              ),
              others_source: this.toNumber(
                stpUserInfo?.incomeOther ?? income?.other,
              ),
              salaryOfInstructorsAndStaff: this.toNumber(
                stpUserInfo?.salary ?? expense?.salary,
              ),
              incidentalExpenses: this.toNumber(
                stpUserInfo?.incidental ?? expense?.incidental,
              ),
              repairingCost: this.toNumber(
                stpUserInfo?.repairing ?? expense?.repairing,
              ),
              examinationExpenses: this.toNumber(
                stpUserInfo?.exam ?? expense?.exam,
              ),
              travelExpenses: this.toNumber(
                stpUserInfo?.travel ?? expense?.travel,
              ),
              procurementOfBooks: this.toNumber(
                stpUserInfo?.procBooks ?? expense?.procBooks,
              ),
              procurementOfTrainingLearningMaterials: this.toNumber(
                stpUserInfo?.procTraining ?? expense?.procTraining,
              ),
              procurementOfRawMaterials: this.toNumber(
                stpUserInfo?.procRawMat ?? expense?.procRawMat,
              ),
              others_head: this.toNumber(
                stpUserInfo?.expenditureOthers ?? expense?.others,
              ),
              totalIncomes:
                this.toNumber(stpUserInfo?.feesFromStudent ?? income?.feesFromStudent) +
                this.toNumber(stpUserInfo?.ownAssetIncome ?? income?.ownAssetIncome) +
                this.toNumber(stpUserInfo?.govIncome ?? income?.govIncome) +
                this.toNumber(stpUserInfo?.developmentCharge ?? income?.developmentCharge) +
                this.toNumber(stpUserInfo?.admissionFee ?? income?.admissionFee) +
                this.toNumber(stpUserInfo?.examFee ?? income?.examFee) +
                this.toNumber(stpUserInfo?.sessionCharge ?? income?.sessionCharge) +
                this.toNumber(stpUserInfo?.prodSell ?? income?.prodSell) +
                this.toNumber(stpUserInfo?.incomeOther ?? income?.other),

              totalExpenses:
                this.toNumber(stpUserInfo?.salary ?? expense?.salary) +
                this.toNumber(stpUserInfo?.incidental ?? expense?.incidental) +
                this.toNumber(stpUserInfo?.repairing ?? expense?.repairing) +
                this.toNumber(stpUserInfo?.exam ?? expense?.exam) +
                this.toNumber(stpUserInfo?.travel ?? expense?.travel) +
                this.toNumber(stpUserInfo?.procBooks ?? expense?.procBooks) +
                this.toNumber(stpUserInfo?.procTraining ?? expense?.procTraining) +
                this.toNumber(stpUserInfo?.procRawMat ?? expense?.procRawMat) +
                this.toNumber(stpUserInfo?.expenditureOthers ?? expense?.others),
            };
            this.stpTrainers = data?.stpTrainers ?? [];
            this.stpOccupationTools = data?.stpTools ?? [];
            this.furnitures = data?.stpFurnitures ?? [];
            this.stpManagements = data?.stpStaffs ?? [];
            this.isApplicationSubmitted = data?.isApplicationSubmitted;
            this.stpRegistrationService.setCheckIsCompleteRegistration(
              this.isApplicationSubmitted,
            );

            this.getJsonStringFromIndex();

            this.isComplete$ = this.stpRegistrationService
              .getCheckIsCompleteRegistration()
              .subscribe((res) => {
                this.isApplicationSubmitted = res;
              });
          } else {
            this.notification.error('Failed', 'STP Application Not Found!');
          }
        },
        (error) => {
          this.notification.error('Failed', 'STP Application Not Found!');
        },
      );
  }
  //#endregion

  //#region Preview
  handleOkFile(): void {
    this.isVisibleForAttachment = false;
  }

  handleCancelFile(): void {
    this.isVisibleForAttachment = false;
  }

  // Size of the attached files (already attached + the new selection), as on the course/center report
  private getTotalSizeInBytes(newFiles: File[] = []): number {
    const existingSize = this.previewAttachments.reduce(
      (sum, f) => sum + (f.fileSize ?? 0),
      0
    );
    const newSize = newFiles.reduce((sum, f) => sum + f.size, 0);
    return existingSize + newSize;
  }

  uploadFiles(event: any) {
    if (event.target.files.length > 0) {
      let totalUploadfiles =
        event.target.files.length + this.previewAttachments.length;
      if (totalUploadfiles > 5) {
        this.notification.error('Error', "Can't upload more than 5 files");
        this.fileElement.nativeElement.value = null;
        return;
      }
      const totalSizeInMB =
        this.getTotalSizeInBytes(Array.from(event.target.files)) / (1024 * 1024);
      if (totalSizeInMB > 50) {
        this.notification.error('Error', 'Total file size must not exceed 50 MB');
        this.fileElement.nativeElement.value = null;
        return;
      }
      event.target?.files?.forEach((item: any, index: number) => {
        this.fileList.push(item);
        this.previewAttachments.push({
          fileName: item.name,
          fileObjectUrl: URL.createObjectURL(item),
          fileUrl: '',
          fileType: this.getFileTypeFromNewAttachment(item.type),
          fileIndex: this.fileList.length - 1,
          isPreviousFile: false,
          fileSize: item.size,
        });
      });
      this.fileElement.nativeElement.value = null;
      this.isFileUpload = true;
      this.saveBtnDisabled = false;
    }
  }

  getFileTypeFromNewAttachment(fileType: string) {
    let contentType = '';
    if (fileType.match(/image/)) {
      contentType = 'image';
    } else if (fileType == 'application/pdf') {
      contentType = 'pdf';
    } else {
      contentType = 'other';
    }
    return contentType;
  }

  previewAllImage(index: number, fielType: string | undefined) {
    this.imageURL = '';
    this.pdfUrl = '';
    this.otherPdfUrl = '';
    if (fielType == 'image') {
      this.isVisibleForAttachment = true;
      this.imageURL = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.previewAttachments[index].fileObjectUrl ?? '',
      );
    } else if (fielType == 'pdf') {
      this.isVisibleForAttachment = true;
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.previewAttachments[index].fileObjectUrl ?? '',
      );
    } else {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute(
        'href',
        this.previewAttachments[index].fileObjectUrl ?? '',
      );
      link.setAttribute('download', this.previewAttachments[index].fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }

  getExtensionFromUrl(url: string) {
    let fileType: string = '';
    let basename = url.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    fileType = basename?.slice(pos + 1) ?? '';
    return fileType;
  }

  // previewImageWhenUpdating(index: number, file: Attachment) {
  //   this.imageURL = '';
  //   this.pdfUrl = '';
  //   this.otherPdfUrl = '';
  //   let basename = file.fileUrl.split(/[\\/]/).pop();
  //   let pos = basename?.lastIndexOf('.') ?? 0;
  //   let fileType = basename?.slice(pos + 1) ?? '';
  //   if (this.imageTypeArray.includes(fileType)) {
  //     this.isVisibleForAttachment = true;
  //     this.imageURL = environment.fileServiceApiUrl + file.fileUrl;
  //   } else if (fileType.trim() == 'pdf') {
  //     let fileFromUrl = this.getBase64FromUrl(
  //       environment.fileServiceApiUrl + file.fileUrl
  //     );

  //     this.isVisibleForAttachment = true;
  //   } else {
  //     this.otherPdfUrl = environment.fileServiceApiUrl + file.fileUrl;
  //     const link = document.createElement('a');
  //     link.setAttribute('target', '_blank');
  //     link.setAttribute('href', this.otherPdfUrl);
  //     link.setAttribute('download', 'doc');
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   }
  // }

  setPreviousAttachments() {
    this.previewAttachments?.forEach((item: any, index: number) => {
      let obj = { ...item };
      let fileType = this.getExtensionFromUrl(item.fileUrl);
      item.fileType = this.getFileTypeFromPreviousAttachment(fileType);
      item['isPreviousFile'] = true;
      this.setBase64AttachmentforPreviewing(index, item.fileUrl);
    });
  }

  async setBase64AttachmentforPreviewing(index: number, fileUrl: string) {
    const data = await fetch(environment.fileServiceApiUrl + fileUrl);
    if (data.status == 200) {
      const blob = await data.blob();
      this.previewAttachments[index].fileObjectUrl = URL.createObjectURL(blob);
    }
  }

  getFileTypeFromPreviousAttachment(fileUrl: string) {
    let contentType = '';
    let basename = fileUrl.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;

    let fileType = basename?.slice(pos + 1) ?? '';
    if (this.imageTypeArray.includes(fileType)) {
      contentType = 'image';
    } else if (fileType == 'pdf') {
      contentType = 'pdf';
    } else {
      contentType = 'other';
    }
    return contentType;
  }

  async getBase64FromUrl(url: any) {
    const data = await fetch(url);

    const blob = await data.blob();
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(blob),
    );
  }

  isFileTypeImageOrPdf(fileType: String): boolean {
    let isImageorPdf = false;
    if (fileType.match(/image/) || fileType == 'application/pdf') {
      isImageorPdf = true;
    } else {
      isImageorPdf = false;
    }
    return isImageorPdf;
  }

  isFileTypeImageOrPdfforPreviousImage(file: Attachment): boolean {
    let isImageorPdf = false;
    let basename = file.fileUrl.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    let fileType = basename?.slice(pos + 1) ?? '';
    if (this.imageTypeArray.includes(fileType) || fileType == 'pdf') {
      isImageorPdf = true;
    } else {
      isImageorPdf = false;
    }
    return isImageorPdf;
  }

  removeAttachment(previewIndex: number, fileIndex: number | undefined): void {
    if (this.previewAttachments[previewIndex].isPreviousFile) {
      this.removePreviousAttachment(previewIndex, fileIndex);
    } else {
      if (fileIndex != null) {
        this.previewAttachments.splice(previewIndex, 1);
        this.fileList.splice(fileIndex, 1);
        this.notification.success(
          'Success!',
          'Attachment successfully deleted',
        );
      }
    }
  }

  removePreviousAttachment(
    previewIndex: number,
    fileIndex: number | undefined,
  ) {
    let data: fileDeleteRequest = {
      filePath: this.previewAttachments[previewIndex].fileUrl,
      inspectionResultId: null,
      inspectionId: this.inspectionId,
    };
    this.inspectionStorageService
      .deleteStpInspectionAttachmentReport(data)
      .subscribe((res: ServerResponse) => {
        if (res.success) {
          this.previewAttachments.splice(previewIndex, 1);
          this.notification.success(
            'Success!',
            'Attachment successfully deleted',
          );
        } else {
          this.notification.error('Error!', res.message);
        }
      });
  }
  //#endregion preview

  getExtensionFromFilename(fileName: string): string {
    let contentType = '';
    let basename = fileName.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    let fileType = basename?.slice(pos + 1) ?? '';
    return fileType;
  }

  changeFileName(
    item: Attachment,
    templateRef: HTMLInputElement,
    index: number,
  ) {
    let newFileName = templateRef.value;
    let fileIndex =
      item.fileIndex != null && item.fileIndex != undefined
        ? item.fileIndex
        : -1;
    if (fileIndex != -1) {
      let file = this.fileList[fileIndex];
      let extension = this.getExtensionFromFilename(file.name);
      let fileType = file.type;
      let regex1 = /[*.]?([\s]+)?/;
      let regexPattern = new RegExp(regex1.source + extension);
      newFileName =
        newFileName != null
          ? newFileName.replace(regexPattern, '') + '.' + extension
          : '';
      let blob = file.slice(0, file.size, fileType);
      let newFile = new File([blob], newFileName, { type: fileType });
      this.fileList[fileIndex] = newFile;
      this.previewAttachments[index].fileName = this.fileList[fileIndex].name;
      templateRef.value = this.previewAttachments[index].fileName;
    }
  }

  getJsonStringFromIndex() {
    for (let i = 0; i < this.stpInformations.length; i++) {
      let jsonData = '';
      switch (i) {
        case 0:
          jsonData = this.basicProfileForm
            ? JSON.stringify(this.basicProfileForm)
            : '';
          this.inspectionFormArray
            .at(0)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 1:
          jsonData = this.physicalInfraForm
            ? JSON.stringify(this.physicalInfraForm)
            : '';
          this.inspectionFormArray
            .at(1)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 2:
          jsonData = this.stpTrainers ? JSON.stringify(this.stpTrainers) : '';
          this.inspectionFormArray
            .at(2)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 3:
          jsonData = this.stpManagements
            ? JSON.stringify(this.stpManagements)
            : '';
          this.inspectionFormArray
            .at(3)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 4:
          jsonData = this.financialDetailForm
            ? JSON.stringify(this.financialDetailForm)
            : '';
          this.inspectionFormArray
            .at(4)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 5:
          jsonData = this.stpOccupationTools
            ? JSON.stringify(this.stpOccupationTools)
            : '';
          this.inspectionFormArray
            .at(5)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 6:
          jsonData = this.furnitures ? JSON.stringify(this.furnitures) : '';
          this.inspectionFormArray
            .at(6)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
      }
    }
  }

  setStpRegistrationFormGroup(): void {
    this.stpInformations.forEach(
      (item: { name: string; modalIdentity: string }, index: number) => {
        this.inspectionFormArray.push(
          this.fb.group({
            id: [null],
            name: item.name,
            title: item.name,
            modalIdentity: item.modalIdentity,
            isCorrect: [null, Validators.required],
            remarks: [null],
            stpHistory: [null],
            inspectionRegistrationReportId: [null],
          }),
        );
      },
    );
  }

  setStpRegistrationFromResponseFormGroup(): void {
    this.inspectionRegistrationRecords.forEach(
      (item: InspectionRegistrationRecord, index: number) => {
        this.inspectionFormArray.push(
          this.fb.group({
            id: [item.id],
            name: [item.name],
            title: [item.title],
            modalIdentity: item.modalIdentity,
            isCorrect: [
              item.isCorrect != null ? (item.isCorrect ? 1 : 0) : null,
              Validators.required,
            ],
            remarks: [item.remarks],
            stpHistory: [item.stpHistory],
            inspectionRegistrationReportId: [this.reportId],
          }),
        );
      },
    );
  }

  resetForm(): void {}

  addRemoveValidatorForRemarks(index: number) {
    let isCorrect = this.inspectionFormArray.at(index).get('isCorrect')?.value;
    if (isCorrect == 0) {
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.setValidators([Validators.required]);
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.updateValueAndValidity();
    } else {
      this.inspectionFormArray.at(index).get('remarks')?.clearValidators();
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.updateValueAndValidity();
    }
  }

  setDataFromPreviousSaved() {
    this.inspectionRegistrationRecords.forEach(
      (item: InspectionRegistrationRecord, index: number) => {
        switch (index) {
          case 0:
            this.basicProfileForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 1:
            this.physicalInfraForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 2:
            this.stpTrainers =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 3:
            this.stpManagements =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 4:
            this.financialDetailForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 5:
            this.stpOccupationTools =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 6:
            this.furnitures =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
        }
      },
    );
  }

  //#region Stp Sac Inspection Preview by inspection id
  onStpSacInspectionPreviewByInspectionId(inspectionId: number) {
    this.stpRegistrationRenewReapplyService
      .readStpAndSacRegInspectionReport(inspectionId)
      .subscribe({
        next: (res) => {
          this.isNsdaSubmitted = res?.data?.isNsdaApproved === true;
          this.inspectionRegistrationReportId =
            res?.data?.inspectionRegistrationReport?.id;
          this.scrutinyForm
            .get('inspectionRegistrationReportId')
            ?.patchValue(this.inspectionRegistrationReportId);
          this.stpSacInspectionRegistrationReportList = res.data;
          this.inspectionRegistrationReport =
            res.data?.inspectionRegistrationReport;

          this.inspectionRegistrationRecords =
            res.data?.inspectionRegistrationReport.inspectionRegistrationRecords;

          this.inspectionRegistrationRecords?.forEach(
            (item: InspectionRegistrationRecord, index: number) => {
              item['modalIdentity'] = this.stpInformations[index].modalIdentity;
              item['name'] = this.stpInformations[index].name;
            },
          );
          this.reportId = res.data?.inspectionRegistrationReport.id;
          if (this.inspectionRegistrationRecords?.length > 0) {
            this.setStpRegistrationFromResponseFormGroup();
            this.setDataFromPreviousSaved();
          } else {
            this.setStpRegistrationFormGroup();
            this.getStpApplicationById();
          }

          this.inspectorRecomendation =
            res.data?.inspectionRegistrationReport.inspectorRecommendation;
          let recId = this.inspectorRecomendation?.id;
          this.inspectionForm
            .get('recommendation.inspectorRecommendationId')
            ?.patchValue(recId);

          let remarks = res.data?.inspectionRegistrationReport.inspectorRemarks;
          this.inspectionForm
            .get('recommendation.inspectorRemarks')
            ?.patchValue(remarks);

          this.previewAttachments =
            res?.data?.inspectionRegistrationReport?.inspectionAttachment !=
            null
              ? res?.data?.inspectionRegistrationReport?.inspectionAttachment
              : [];
          this.setPreviousAttachments();
        },
      });
  }
  //#endregion
}
